import { Tabs } from "@mantine/core";
import { useEffect, useState } from "react";
import { grabFeature } from "@/components/feature";
import parse from "html-react-parser";
import { purfifyHTML } from "@/services/services";

export default function Tabs1({ options, props }) {
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [activeColor, setActiveColor] = useState("blue");
  const [variant, setVariant] = useState("default");

  useEffect(() => {
    if (options.tabs && options.tabs.length > 0) {
      setTabs(options.tabs);
      setActiveTab(options.tabs[0].value);
    }
    if (options.activeColor) setActiveColor(options.activeColor);
    if (options.variant) setVariant(options.variant);
  }, [options]);

  if (!(tabs.length > 0)) {
    return <></>;
  }

  function renderTabList() {
    return (
      <Tabs.List position="center">
        {tabs.map((tab, idx) => (
          <Tabs.Tab key={idx} value={tab.value}>
            {parse(purfifyHTML(tab.label))}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    );
  }

  function renderTabPanel() {
    return (
      <>
        {tabs.map((tab, idx) => (
          <Tabs.Panel key={idx} value={tab.value}>
            {grabFeature({
              ...props,
              component: tab.component.component,
              display: tab.component.display,
              options: tab.component.options,
            })}
          </Tabs.Panel>
        ))}
      </>
    );
  }

  return (
    <Tabs
      value={activeTab}
      onTabChange={setActiveTab}
      variant={variant ?? "default"}
      color={activeColor ?? "blue"}
    >
      {renderTabList()}
      {renderTabPanel()}
    </Tabs>
  );
}
